'use client';
import { useState } from 'react';
import { Input } from '~/components';
import { useRegion } from '~/region/hooks';
import { kgToLbs } from '~/utils';

export const FormWeight = ({
  label,
  weight,
  setWeight,
}: {
  label?: string;
  weight: number;
  setWeight: (weight: number) => void;
}) => {
  const { isUs } = useRegion();
  const [kg, setKg] = useState(weight);

  return (
    <div className="space-y-4">
      <div>{label || 'Weight'}</div>

      {isUs ? (
        <div className="flex gap-5">
          <div className="flex items-center gap-4">
            <Input
              className="w-40"
              type="number"
              value={weight}
              min={0}
              onChange={(event) => setWeight(Number(event.target.value))}
            />

            <div className="font-semibold">LB</div>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-4">
          <Input
            className="w-40"
            type="number"
            value={kg}
            onChange={(event) => {
              const newKg = Number(event.target.value);

              setKg(newKg);
              setWeight(kgToLbs(newKg));
            }}
            step={0.1}
            min={0}
          />

          <div className="font-semibold">KG</div>
        </div>
      )}
    </div>
  );
};
